export default "__VITE_ASSET__C63N3GID__"